import React, { useEffect } from 'react';
import { Link } from 'react-router';
import map from 'lodash/map';
import classnames from 'classnames';

import Footer from '../Footer';

import * as analytics from 'shared/lib/analytics';
import seo from 'shared/lib/seo';

import styles from './ProductsPage.module.css';

const ProductsPage = () => {
  useEffect(() => {
    seo.setProps({
      title: 'Sure Products',
      description: "Sure's suite of insurance products",
      url: 'https://www.sureapp.com/insurance-products',
    });
    analytics.page('Products');
  }, []);

  const personalTop = [
    {
      title: 'Renters Insurance',
      to: `https://www.${
        process.env.REACT_APP_AMTRUST_DOMAIN
      }.com/product/amtrust/amtrust-renters-direct/get-started`,
    },
  ];

  const personalBottom = [
    {
      title: 'Home Warranty',
      to: '/home-warranty',
    },
  ];

  const business = [
    {
      title: 'Small Business Insurance',
      to: '/small-business-owners-insurance',
    },
  ];

  const travel = [
    {
      title: 'Baggage Protection',
      to: '/baggage-protection',
    },
    {
      title: 'Rental Car Insurance',
      to: '/rental-car-insurance',
    },
  ];

  return (
    <div className={styles.productsPage}>
      <div className={styles.header}>
        <h1 className={styles.headline}>Insurance</h1>
      </div>

      <div className={styles.container}>
        <h2 className={styles.title}>Personal</h2>
        <ul className={styles.list}>
          {map(personalTop, (link, i) => (
            <li className={styles.list_item} key={i}>
              <a
                href={link.to}
                className={classnames(styles.list_link, styles.externalLink)}
              >
                {link.title}
              </a>
            </li>
          ))}
          {map(personalBottom, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>

        <h2 className={styles.title}>Business</h2>
        <ul className={styles.list}>
          {map(business, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>

        <h2 className={styles.title}>Travel</h2>
        <ul className={styles.list}>
          {map(travel, (link, i) => (
            <li className={styles.list_item} key={i}>
              <Link className={styles.list_link} to={link.to}>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <Footer />
    </div>
  );
};

export default ProductsPage;
